import React from 'react';

const TermsNConditions = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', lineHeight: '1.6' }}>
      <h2>Terms and Conditions</h2>
      <p><strong>Last updated on April 06, 2025</strong></p>

      <p>
        Welcome to <strong>CIRAYEDAAR</strong>. By accessing or using our website and services, you agree to be bound by the following Terms and Conditions. Please read them carefully.
      </p>

      <p>
        For the purposes of these Terms and Conditions, “we”, “us”, and “our” refer to CIRAYEDAAR, whose registered/operational office is located at:
        <br />
        Flat No 1, Khalsa Tent House Wali Gali, Kamalpur, Aligarh, Uttar Pradesh 202001.
        <br />
        “You”, “your”, “user”, or “visitor” refers to any natural or legal person who accesses or uses our website or services.
      </p>

      <h3>1. Website Use</h3>
      <ul>
        <li>The content and information provided on this website are for general information purposes only and are subject to change without prior notice.</li>
        <li>Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.</li>
        <li>Your use of any information or materials on this website is entirely at your own risk. We shall not be liable for any inaccuracies or errors to the fullest extent permitted by law.</li>
        <li>You are responsible for ensuring that any products, services, or information available through this website meet your specific requirements.</li>
      </ul>

      <h3>2. Intellectual Property</h3>
      <ul>
        <li>All content, design, layout, graphics, and other material on the website are the property of CIRAYEDAAR unless otherwise stated.</li>
        <li>Reproduction, duplication, or distribution of any content without prior written consent from CIRAYEDAAR is strictly prohibited.</li>
        <li>All trademarks reproduced on this website that are not the property of CIRAYEDAAR are acknowledged.</li>
      </ul>

      <h3>3. Third-Party Links</h3>
      <p>Our website may contain links to other websites for your convenience or to provide additional information. These links do not signify our endorsement of the external site(s), and we hold no responsibility for the content or practices of those websites.</p>

      <h3>4. External Linking</h3>
      <p>You may not create a link to this website from another website or document without our prior written consent.</p>

      <h3>5. Limitation of Liability</h3>
      <ul>
        <li>CIRAYEDAAR, its employees, agents, or representatives shall not be held liable for any loss or damage, direct or indirect, arising from the use of this website or services.</li>
        <li>We make no warranties or guarantees regarding the accuracy, timeliness, or suitability of the materials and information found on this website.</li>
      </ul>

      <h3>6. Payment & Authorization</h3>
      <p>CIRAYEDAAR is not responsible for any loss or damage arising from the decline of authorization for any transaction due to the cardholder exceeding their preset limit as agreed with their bank.</p>

      <h3>7. Cancellation and Refund Policy</h3>
      <p><strong>Last updated on April 06, 2025</strong></p>
      <ul>
        <li>In case of any unpromised service, users must report the issue within 24 hours to our Customer Service team for review.</li>
        <li>If the service does not match the description or expectations, it should also be reported within 24 hours. Our team will investigate and take appropriate action.</li>
        <li>Due to the nature of our services and our minimal service charges, refunds are not applicable. We strongly advise users to carefully review all service details before making a booking.</li>
        <li>For any queries or concerns, please contact us before finalizing your booking.</li>
      </ul>

      <h3>8. Shipping and Delivery</h3>
      <p><strong>Last updated on April 06, 2025</strong></p>
      <p>Shipping is not applicable for our services. All offerings are service-based and are delivered digitally or in person as per agreement.</p>

      <h3>9. Governing Law</h3>
      <p>These Terms and Conditions shall be governed and interpreted in accordance with the laws of India. Any disputes arising from the use of this website or our services shall fall under the exclusive jurisdiction of the courts in Aligarh, Uttar Pradesh, India.</p>

      <h3>10. Contact Information</h3>
      <p>
        For any queries regarding these Terms and Conditions, you may contact:
        <br /><br />
        <strong>CIRAYEDAAR</strong><br />
        Flat No 1, Khalsa Tent House Wali Gali,<br />
        Kamalpur, Aligarh, Uttar Pradesh 202001<br />
        Email: <em>[Add your email here]</em><br />
        Phone: <em>[Add your phone number here]</em>
      </p>
    </div>
  );
};

export default TermsNConditions;
